import React from "react";
import { useState, useEffect } from "react";

import { Navigate } from "react-router-dom";

import { getRequest } from "../../api/axiosRequests";
import SearchBar from "../../common/components/SearchBar";
import PlanForm from "../components/PlanForm";
import CardAdminPlan from "../components/CardAdminPlan";
import { Container } from "react-bootstrap";

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [currentPlan, setCurrentPlan] = useState({ id: -1 });
  const [showEditForm, setShowEditForm] = useState(false);

  async function fetchPlans() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise = getRequest("planList/", headers);
    promise
      .then((res) => {
        const plansData = res["data"];
        setPlans(plansData);
        setFilteredPlans(plansData);
      })
      .catch((errs) => {
        console.log(errs);
      });
  }

  // Button Callbacks
  const onSearchChange = (name) => {
    const nameLowerCase = name.toLowerCase();
    const filtered = plans.filter((plan) =>
      plan.name.toLowerCase().includes(nameLowerCase)
    );
    setFilteredPlans(filtered);
  };

  const showEditFormCallback = () => {
    setCurrentPlan({ id: -1 });
    setShowEditForm(true);
  };

  const editCallback = (id) => {
    const currentPlan = plans.filter((p) => p.id === id)[0];
    setCurrentPlan(currentPlan);
    setShowEditForm(true);
  };

  const closeEditFormCallback = () => {
    setShowEditForm(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPlans();
  }, []);

  return (
    <Container className="mt-2" style={{ paddingBottom: 10 }}>
      <PlanForm
        getCurrentPlan={() => {
          return currentPlan;
        }}
        onHide={closeEditFormCallback}
        show={showEditForm}
        onSubmit={() => {
          fetchPlans();
        }}
      />
      <div className="align-self-center text-center">
        <div>
          <SearchBar
            onChange={onSearchChange}
            addButton={true}
            onAdd={showEditFormCallback}
          />
        </div>
        <div style={{ width: "100%" }}>
          <div>
            {filteredPlans.map((plan) => (
              <div key={plan.id}>
                <CardAdminPlan
                  height={80}
                  plan={plan}
                  isActive={false}
                  editCallback={editCallback}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}
